import React, { useState, useEffect, useCallback, useRef } from "react";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import {
  Typography,
  Box,
  Button,
  TextField,
  CircularProgress,
  LinearProgress,
  IconButton,
  InputAdornment,
  Grid,
  InputLabel,
} from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import iconSearchs from "../../../../../src/assets/iconSearchs.svg"
import AddCircleIcon from "@mui/icons-material/AddCircle";
import docEnabled from 'assets/docEnabled.svg'
import docDisabled from 'assets/docDisabled.svg'
import uploadCloud from "assets/uploadCloud.svg";
import CrossRed from "assets/CrossRed.svg";
import './ImportList.css'; // Ensure you have appropriate styles
import { Navigate, useNavigate } from "react-router-dom";
import ImportService from "services/ImportService";
import dayjs from 'dayjs';
import { convertToLocalTime, debounceCustom } from "utils/CommonFunction";
import { convertDateString, formatDate } from "utils/utils";
import { SnackbarContext } from "context/snackBarContext";
import NoData from "assets/noData.svg";
import UnsupportedModal from "./UnsupportedModal";
import ConfirmModal from "./ConfirmModal";
import { AuthData } from "auth/AuthWarpper";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { format } from "date-fns";
import CustomPagination from "./CustomPagination";
import ImportStatusModal from "./ImportStatusModal";
import { useTranslation } from "react-i18next";
import dangerIcon from 'assets/danger.svg'
import successIcon from 'assets/successIcon.svg'
import failedIcon from 'assets/failedIcon.svg'
import Warning from 'assets/Warning.svg';
import TemplateDownloadModal from "./TemplateDownloadModal";
import CropYearModal from "./CropYearModal";
import utc from "dayjs/plugin/utc";

let setIlOriginalHEaderId = ''
let iconName = ""
let ImportStatusMessage = ""

let ImportStatusMessageSuccess = "Upload Successful"
let ImportStatusPartialFarmer = "Upload partially completed: - Kindly review the data log and import a new file as it can impact on farmers data"
let ImportStatusPartialContract = "Upload partially completed: - Kindly review the data log and import a new file as it can impact on farmers contract data"
let ImportStatusPartialHierarchy = "Upload partially completed:- Kindly review the data log and import a new file as it can impact on Hierarchy Structure"
let ImportStatusFailedContract = "Upload failed: - Kindly review the data log and import a new file as it can impact on farmers contract data"
let ImportStatusFailedFarmer = "Upload failed: - Kindly review the data log and import a new file as it can impact on farmers data"
let ImportStatusFailedHierarchy = "Upload Failed: - Kindly review the data log and import a new file as it can impact on Hierarchy Structure"
let ImportStatusPartialWoodSupplier = "Upload partially completed: - Kindly review the data log and import a new file as it can impact on Wood Supplier data"
let ImportStatusFailedWoodSupplier = "Upload failed: - Kindly review the data log and import a new file as it can impact on Wood Supplier data"
let ImportStatusPartialFT = "Upload partially completed: - Kindly review the data log and import a new file with correct data"
let ImportStatusFailedFT =  "Upload failed: - Kindly review the data log and import a new file with correct data"

const ImportList = (props) => {
  const fileInputRef = useRef(null);
  const { t, i18n } = useTranslation()
  const { user } = AuthData();
  const navigate = useNavigate();
  const [showUpload, setShowUpload] = useState(false);
  const [importData, setImportData] = useState([
  ]);
  const [openCropYearModal,setOpenCropYearModal]=useState(false);
  // Split from a single shared "loading" flag: each action tracks its own state so the
  // Export button / search bar spinners don't light up while an unrelated upload is in flight.
  const [listLoading, setListLoading] = useState(false);
  const [uploadLoading, setUploadLoading] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);
  const [startDateOpen, setStartDateOpen] = useState(false);
  const [endDateOpen, setEndDateOpen] = useState(false);
  const [startDate, setStartDate] = useState(dayjs().subtract(6, 'month').startOf('day'));
  const [endDate, setEndDate] = useState(dayjs().endOf('day'));
  const [searchInput, setSearchInput] = React.useState(null);
  const [userInput, setUserInput] = useState('')
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(20); // Number of items per page
  const [totalItems, setTotalItems] = useState(7); // Num
  const {
    setOpenAlert,
    setSeverity,
    setMessage,
  } = React.useContext(SnackbarContext);
  const [openModal, setOpenModal] = useState(false);
  const [openCancelModal, setOpenCancelModal] = useState(false);
  const [openTemplateDownloadModal, setOpenTemplateDownloadModal] = useState(false); // Add state for template download modal
  const [fileInputKey, setFileInputKey] = useState(Date.now()); // Unique key for resetting input
  const [comment, setComments] = useState("")
  const [cancelTokens, setCancelTokens] = useState({});
  const [pollingIntervals, setPollingIntervals] = useState({});
  // Define min and max dates for the pickers
  const minDate = dayjs().subtract(6, 'month').startOf('day');
  const maxDate = dayjs().endOf('day');
  const [progresses, setProgresses] = useState({});
  const [selectedFile, setSelectedFile] = useState(null);
  const [openStatusModal, setOpenStatusModal] = useState(false);
  const[iconLoaded,setIconLoaded]=useState(false)
  const [cancelledItems, setCancelledItems] = useState(new Set()); // Track cancelled items
  const pollTickRef = useRef(0);
  const progressStallRef = useRef({}); // { [ilHeaderId]: { value, lastChangedAt } } - tracks how long a row's progress % has been unchanged
  const stalledStatusCheckedRef = useRef(new Set()); // ilHeaderIds already status-checked due to a stalled progress bar, so we don't re-ask every tick

const moduleName = "Data Import";
let functionalityName = ''
        if (props?.entityName == 'ImportFarmer') {
          functionalityName = 'Import Farmer'
        }   
        if (props?.entityName == 'ImportHierarchy') {
          functionalityName ='Import Hierarchy'
        }
        if (props?.entityName == 'ImportContract') {
          functionalityName ='Import Contract'
        }
        if (props?.entityName == 'ImportWood') {
          functionalityName ='Import Wood Supplier'
        }
        if (props?.entityName == 'ImportFTFAMapping') {
          functionalityName ='Import FT to FA Mapping'
        }
    
      const read_only_user = user?.accessibleModules
        ?.find(module => module.module_name === moduleName)
        ?.accessible_functionalities
        ?.find(func => func.functionality_name === functionalityName)
        ?.read_only;

   
  useEffect(() => {
    callListAPI(currentPage, itemsPerPage);
    
    // Cleanup function to clear any pending operations on unmount
    return () => {
      setProgresses({});
      setSelectedFile(null);
      setCancelledItems(new Set());
      progressStallRef.current = {};
      stalledStatusCheckedRef.current = new Set();
    };
  }, [])

  useEffect(() => {
    // Update end date if it becomes earlier than start date
    if (endDate.isBefore(startDate)) {
      setEndDate(startDate);
    }
    setCurrentPage(0)
    callListAPI(0, itemsPerPage, searchInput)
  }, [startDate, endDate]);

  const callListAPI = ((pNumber, size, searchquery, silent = false) => {
    let sDate = dayjs(startDate).format('DD-MM-YYYY')
    let eDate = dayjs(endDate).format('DD-MM-YYYY')
    if (!silent) setListLoading(true)

    // Use ImportWoodSupplier as entity name for ImportWood, otherwise use the original entity name
    const entityName = props?.entityName === 'ImportWood' ? 'ImportWoodSupplier' : props?.entityName;

    ImportService.FetchImportList({ entityName: entityName, startDate: sDate, endDate: eDate, pageNumber: pNumber, size: size, searchquery })
      .then(res => {
        let resp = res?.data?.response;
        setImportData(resp?.importLogHeader)
        setCurrentPage(pNumber)
        setItemsPerPage(size)
        setTotalItems(res?.data?.response?.totalItems)
        if (!silent) setListLoading(false)

        // Clean up cancelled items list - only keep items that are still in progress
        const currentInProgressIds = new Set(
          (resp?.importLogHeader || [])
            .filter(item => item.uploadStatus && item.uploadStatus.includes('InProgress'))
            .map(item => item.ilHeaderId)
        );

        setCancelledItems(prev => {
          const filteredCancelled = new Set();
          prev.forEach(id => {
            if (currentInProgressIds.has(id)) {
              filteredCancelled.add(id);
            }
          });
          return filteredCancelled;
        });

      })
      .catch(error => {
        // A silent (background) refresh failing shouldn't wipe the currently displayed table
        // or pop an error alert - just skip this attempt and let the next one reconcile.
        if (silent) return;
        setImportData([])
        setMessage(error?.response?.data?.message || error?.message)
        setOpenAlert(true)
        setSeverity("error")
        setListLoading(false)
      });
  })
  const STATUS_CHECK_MAX_RETRIES = 5;
  const STATUS_CHECK_RETRY_DELAY_MS = 2000;

  const callImportStatusAPI = ((IlHeaderId, retryCount = 0) => {
    setUploadLoading(true)
    let apiName = ''
        if (props?.entityName == 'ImportFarmer') {
          apiName = 'farmer-import'
        }
        if (props?.entityName == 'ImportHierarchy') {
          apiName ='hierarchy-import'
        }
        if (props?.entityName == 'ImportContract') {
          apiName ='import-contract'
        }
        if (props?.entityName == 'ImportWood') {
          apiName = 'wood-supplier-import'
        }
        if (props?.entityName == 'ImportFTFAMapping') {
          apiName = 'ft-fa-mapping-import'
        }

        ImportService.fetchImportStatusAPI({ entityName: apiName, IlHeaderId: IlHeaderId })
      .then(res => {
        let resp = res?.data?.response;
        setUploadLoading(false)
        if (props?.entityName == 'ImportFarmer') {
          if (resp == "Upload Failed") {
            iconName = failedIcon
            ImportStatusMessage = ImportStatusFailedFarmer
          }
          else if (resp == "Upload Successful") {
            iconName = successIcon
            ImportStatusMessage = ImportStatusMessageSuccess
          }
          else if (resp == "Partial Upload Successful") {
            iconName = dangerIcon
            ImportStatusMessage = ImportStatusPartialFarmer
          }
        }
        if (props?.entityName == 'ImportHierarchy') {
          if (resp == "Upload Failed") {
            iconName = failedIcon
            ImportStatusMessage = ImportStatusFailedHierarchy
          }
          else if (resp == "Upload Successful") {
            iconName = successIcon
            ImportStatusMessage = ImportStatusMessageSuccess
          }
          else if (resp == "Partial Upload Successful") {
            iconName = dangerIcon
            ImportStatusMessage = ImportStatusPartialHierarchy
          }
        }
        if (props?.entityName == 'ImportContract') {
          if (resp == "Upload Failed") {
            iconName = failedIcon
            ImportStatusMessage = ImportStatusFailedContract
          }
         else if (resp == "Upload Successful") {
            iconName = successIcon
            ImportStatusMessage = ImportStatusMessageSuccess
          }
          else if (resp == "Partial Upload Successful") {
            iconName = dangerIcon
            ImportStatusMessage = ImportStatusPartialContract
          }
        }
        if (props?.entityName == 'ImportWood') {
          if (resp == "Upload Failed") {
            iconName = failedIcon
            ImportStatusMessage = ImportStatusFailedWoodSupplier
          }
          else if (resp == "Upload Successful") {
            iconName = successIcon
            ImportStatusMessage = ImportStatusMessageSuccess
          }
          else if (resp == "Partial Upload Successful") {
            iconName = dangerIcon
            ImportStatusMessage = ImportStatusPartialWoodSupplier
          }
        }
        if (props?.entityName == 'ImportFTFAMapping') {
          if (resp == "Upload Failed") {
            iconName = failedIcon
            ImportStatusMessage = ImportStatusFailedFT
          }
          else if (resp == "Upload Successful") {
            iconName = successIcon
            ImportStatusMessage = ImportStatusMessageSuccess
          }
          else if (resp == "Partial Upload Successful") {
            iconName = dangerIcon
            ImportStatusMessage = ImportStatusPartialFT
          }
        }
         if (resp !== "Upload Failed" && resp !== "Upload Successful" && resp !== "Partial Upload Successful") {
          if (retryCount < STATUS_CHECK_MAX_RETRIES) {
            setTimeout(() => {
              callImportStatusAPI(IlHeaderId, retryCount + 1);
            }, STATUS_CHECK_RETRY_DELAY_MS);
          }
          return;
        }
       const img = new Image();
      img.src = iconName;
      img.onload = () => {
        setIconLoaded(true);
        setOpenStatusModal(true);
      };
      })
      .catch(error => {
        setMessage(error?.response?.data?.message || error?.message)
        setOpenAlert(true)
        setSeverity("error")
        setUploadLoading(false)
      });
  })
  const onSearch = useCallback(
    debounceCustom((searchquery, pageSize) => {
      setSearchInput(searchquery)
      if (searchquery != "") {
        const params = new URLSearchParams();
        params.append('userInput', searchquery)
        setUserInput(searchquery);
        callListAPI(0, pageSize, searchquery)
      } else {
        callListAPI(0, pageSize)
      }
    }, 1000)
  );
  const getStatusColor = (status) => {
    switch (status) {
      case 'Upload Successful':
        return 'green';
      case 'Upload Failed':
        return 'red';
      case 'Upload Cancelled':
        return 'red';
      case 'InProgress':
        return 'green';
      case 'Partial Upload Successful':
        return '#F2BB40';
      default:
        return 'black';
    }
  };
  const handleEntityRedirect = (id) => {
    if (props?.entityName == "Farmer") {
      Navigate('/')
    } else if (props?.entutyName == "Hierarchy") {
      Navigate('/')
    } else {
      Navigate('/')
    }
  }

  const handleViewLog = (id, additionalData) => {
    let routeName = ''
    if (props?.entityName == "ImportFarmer") {
      routeName = 'viewFarmerLog'
    } else if (props?.entityName == "ImportContract") {
      routeName = 'viewContractLog'
    } else if (props?.entityName == "ImportWood") {
      routeName = 'viewWoodLog'
    } else if (props?.entityName == "ImportFTFAMapping") {
      routeName = 'viewFTLog'
    } else {
      routeName = 'viewHierarchyLog'
    }
    navigate(`/${routeName}/${id}`, { state: additionalData });
  };

 

 const handleCloseCropYearModal = () => {
    setOpenCropYearModal(false);
  };

  const handleConfirmYear = (cropYear) => {
    setOpenCropYearModal(false);
    if(cropYear){
      if (props?.entityName == 'ImportContract') {
        downloadContractData(cropYear);
        return;
      }
      if (props?.entityName == 'ImportHierarchy') {
        performDownload(true, cropYear);
        return;
      }
    }
    else{
       setOpenAlert(true)
       setMessage("No Crop Year Found")
        setSeverity("error")
    }
  };

     
 const downloadContractData = async (cropYear) => {
  try {
    const response = await ImportService.downloadContract(cropYear);
    const contractData = response?.data?.response || [];

    // Define column headers exactly as you want them
    const headers = [
      'Le_Legacy_Grower_No',
      'C_Property_Farm_No',
      'C_Legacy_Contract_No',
      'C_Year',
      'C_CropSeason',
      'C_Tobacco_Type',
      'C_Curing_Type_Tobacco',
      'C_GrowerType',
      'C_Biodiversity_Risk',
      'C_BMP',
      'C_Active',
      'C_Total_Farm_Area',
      'C_Tobacco_Contracted_Hectares',
      'C_Tobacco_Planted_Hectares'
    ];

    let exportData;

    if (contractData.length === 0) {
      // If no records, create an empty array with just one object with keys from headers and empty values
      exportData = [headers.reduce((acc, key) => ({ ...acc, [key]: "" }), {})];
    } else {
      exportData = contractData.map(item => ({
        'Le_Legacy_Grower_No':item.legacyGrowerNo,
        'C_Property_Farm_No':item.propertyFarmNo,
        'C_Legacy_Contract_No':item.legacyContractNO,
        'C_Year': item.cropYear,
       'C_CropSeason': item.cropSeason,
        'C_Tobacco_Type': item.tobaccoType,
        'C_Curing_Type_Tobacco': item.curingTobaccoType,
        'C_GrowerType': item.growerType,
        'C_Biodiversity_Risk': item.biodiversityRisk,
        'C_BMP': item.bmp,
        'C_Active': item.isActive,
        'C_Total_Farm_Area': item.totalFarmArea,
        'C_Tobacco_Contracted_Hectares': item.tobaccoContractedHectares,
        'C_Tobacco_Planted_Hectares': item.tobaccoPlantedHectares
      }));
    }

    // Build CSV manually (browser-safe) and escape fields
    const escapeField = (val) => {
      if (val === null || val === undefined) return '';
      let s = String(val);
      // Preserve leading zero-width-space or tab if present
      const leading = s.startsWith('\u200B') ? '\u200B' : (s.startsWith('\t') ? '\t' : '');
      if (leading) s = s.slice(leading.length);
      // Escape double quotes
      if (s.includes('"')) s = s.replace(/"/g, '""');
      // Wrap in quotes if contains special chars
      if (/[",\n\r]/.test(s)) s = '"' + s + '"';
      return leading + s;
    };

    const headerRow = headers.join(',');
    const rows = exportData.map(row => headers.map(h => escapeField(row[h])).join(','));
    const csv = [headerRow, ...rows].join('\n');
    const bom = '\uFEFF';
    const blob = new Blob([bom + csv], { type: 'text/csv;charset=utf-8;' });
    saveAs(blob, `Import_Contract_Template.csv`);

  } catch (err) {
    console.error('Error fetching contract:', err);
  }
};


  const handleDownloadTemplate = async (e, isTemplate) => {
    e.preventDefault();
    
    // If it's a template download, show the modal first
    if (isTemplate && (props?.entityName == 'ImportContract' || props?.entityName == 'ImportHierarchy')) {
      //setOpenTemplateDownloadModal(true);
       setOpenCropYearModal(true);
      return;
    }
    
    // If it's not a template (user guide), download directly
    await performDownload(isTemplate);
  };

  const performDownload = async (isTemplate, cropYear) => {
    let entity = ''
    if (props?.entityName == 'ImportFarmer') {
      entity = 'farmer'
    }
    if (props?.entityName == 'ImportHierarchy') {
      entity = 'hierarchy'
    }
    if (props?.entityName == 'ImportContract') {
      entity = 'contract'
    }
    if (props?.entityName == 'ImportWood') {
      entity = 'Wood_Supplier'
    }
    if (props?.entityName == 'ImportFTFAMapping') {
      entity = 'FT_FA_Mapping'
    }
    if(!isTemplate){
         downloadExcelFile(entity ,isTemplate)
         return
    }

    try {
      const response = await ImportService.DownloadFile({ name: entity, isTemplate: isTemplate, cropYear }, {
        responseType: 'text' // Expecting the response as plain text (CSV content)
      });
      if (response.status !== 200) {
        throw new Error('Network response was not ok');
      }
      let fileName = "File"
      const contentDisposition = response.headers.get('Content-Disposition');
      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename="([^"]+)"/);
        const filename = filenameMatch && filenameMatch[1];
        if (filename) {
          fileName = filename
        }
      }
      const fileContent = response.data;
      console.log('File content received:', fileContent); // Log the file content for debugging
      // Create a Blob from the text content
      const blob = new Blob([fileContent], { type: 'text/csv' }); // Ensure MIME type is 'text/csv'
      // Create a URL for the Blob and trigger a download
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName; // Set the file name for download
      document.body.appendChild(a); // Append the anchor to the document
      a.click(); // Trigger the download
      document.body.removeChild(a); // Remove the anchor from the document
      window.URL.revokeObjectURL(url); // Clean up the object URL
    } catch (error) {
      console.error('Error downloading file:', error);
      // Handle the error (e.g., show a message to the user)
    }
  };


  const downloadExcelFile = async (entity,isTemplate) => {
    try {
      const response = await ImportService.DownloadExcelFile({ name: entity, isTemplate: isTemplate }, {});
      if (response.status !== 200) {
        throw new Error('Network response was not ok');
      }
      const disposition = response.headers['content-disposition'];
      const filename =
        disposition?.split('filename=')[1]?.replace(/"/g, '') || 'download.xlsx';
      saveAs(response.data, filename);
    } catch (error) {
      console.error('Download failed:', error);
    }
  };
  
  // Handler for template download modal confirmation
  const handleTemplateDownloadConfirm = () => {
    setOpenTemplateDownloadModal(false);
    performDownload(true); // Download the template
  };


  const handleCloseModal = () => {
    setOpenModal(false);
  };
  const paginate = (pageNumber, itemsPerPage) => {
    callListAPI(pageNumber - 1, itemsPerPage, searchInput)
  }
  ///handle file uploads 

  const handleBackButton = () => {
    callListAPI(0, itemsPerPage)
    setShowUpload(false)
  }

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file && !file.name.endsWith('.csv')) {
        setOpenModal(true);
      } else {
        setFileInputKey(Date.now()); // Reset input field
        callUploadAPI(file)
      }
    }
  };
  const clearFileInput = () => {
    setOpenModal(false)
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };
  const callUploadAPI = (file) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('username', user?.userName);
    setUploadLoading(true)

    let importTime = format(new Date(), "HH:mm:ss");
    let importDate = format(new Date(), "yyyy-MM-dd");

    // Use ImportWoodSupplier as entity name for ImportWood
    let entityName = props?.entityName === 'ImportWood' ? 'ImportWoodSupplier' : props?.entityName;

    ImportService.UploadFile({ entityName: entityName, comment: comment, username: user?.userName, file: formData, importDate: importDate, importTime: importTime })
      .then(res => {
        let resp = res?.data?.response;
        callStartProcess(resp)
      })
      .catch(error => {
        callListAPI(0, itemsPerPage)
        setShowUpload(false)
        setMessage(error?.response?.data?.message || error?.message)
        setOpenAlert(true)
        setSeverity("error")
        setUploadLoading(false)
      });
  }

  const callStartProcess = (data) => {
    let callAPIPRomise = ''
    if (props?.entityName == 'ImportFarmer') {
      callAPIPRomise = ImportService.UploadStartProcess(data?.ilHeaderId)
    }
    if (props?.entityName == 'ImportHierarchy') {
      callAPIPRomise = ImportService.ImportHierarchyProcessStart(data?.ilHeaderId)
    }
    if (props?.entityName == 'ImportContract') {
      callAPIPRomise = ImportService.ImportContractProcessStart(data?.ilHeaderId)
    }
    if (props?.entityName == 'ImportWood') {
      callAPIPRomise = ImportService.UploadWoodSupplierProcessStart(data?.ilHeaderId)
    }
    if (props?.entityName == 'ImportFTFAMapping') {
      callAPIPRomise = ImportService.UploadFTFAProcessStart(data?.ilHeaderId)
    }
    // ImportService.ImportHierarchyProcessStart(data?.ilHeaderId)
    callAPIPRomise.then(res => {
      let resp = res?.data?.response;
      setUploadLoading(false)
      setShowUpload(false)

      if(props?.entityName == "ImportHierarchy"){
        setTimeout(() => {
          callListAPI(0, itemsPerPage)
          }, 1000);
      }else{
        callListAPI(0, itemsPerPage)
      }
    })
      .catch(error => {
        setShowUpload(false);
        callListAPI(currentPage, itemsPerPage);
        setMessage(error?.response?.data?.message || error?.message)
        setOpenAlert(true)
        setSeverity("error")
        setUploadLoading(false)
      });
  }

  const handleCancelClick = (id) => {
    setSelectedFile(id);
    setOpenCancelModal(true);
  };


  const callancelProgress = (id) => {
    ImportService.ImportHierarchyLogCancel({ id })
      .then(res => {
        let resp = res?.data?.response;
        callListAPI(currentPage, itemsPerPage);
      })
      .catch(error => {
        setMessage(error?.response?.data?.message || error?.message)
        setOpenAlert(true)
        setSeverity("error")
      });
  }
  const handleCancelConfirm = () => {
    setOpenCancelModal(false)
    if (selectedFile) {
      // IMMEDIATELY mark this item as cancelled to stop polling before API call
      setCancelledItems(prev => new Set([...prev, selectedFile]));
      
      // Clear progress for this file immediately to stop polling
      setProgresses(prev => {
        const newProgresses = { ...prev };
        delete newProgresses[selectedFile];
        return newProgresses;
      });

      // Also update the local importData state immediately to reflect failed status
      setImportData(prev => prev.map(item => 
        item.ilHeaderId === selectedFile 
          ? { ...item, uploadStatus: 'Upload Failed' }
          : item
      ));

      let callAPIPRomise = ''
      if (props?.entityName == 'ImportFarmer') {
        callAPIPRomise = ImportService.UploadCancel({ id: selectedFile })
      }
      if (props?.entityName == 'ImportHierarchy') {
        callAPIPRomise = ImportService.ImportHierarchyLogCancel({ id: selectedFile })
      }
      if (props?.entityName == 'ImportContract') {
        callAPIPRomise = ImportService.ImportContractLogCancel({ id: selectedFile })
      }
      if (props?.entityName == 'ImportWood') {
        callAPIPRomise = ImportService.WoodSupplierLogCancel({ id: selectedFile })
      }
      if (props?.entityName == 'ImportWood') {
        callAPIPRomise = ImportService.WoodSupplierLogCancel({ id: selectedFile })
      }
      if (props?.entityName == 'ImportFTFAMapping') {
        callAPIPRomise = ImportService.FTFALogCancel({ id: selectedFile })
      }

      // ImportService.ImportHierarchyLogCancel({ id: selectedFile })
      callAPIPRomise.then(res => {
        // Force refresh the data to get updated status from server
        callListAPI(currentPage, itemsPerPage);
        setSelectedFile(null); // Clear selected file
      })
        .catch(error => {
          callListAPI(currentPage, itemsPerPage);
          setMessage(error?.response?.data?.message || error?.message)
          setOpenAlert(true)
          setSeverity("error")
          setSelectedFile(null); // Clear selected file even on error
        });
    }
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      pollTickRef.current += 1;
      const hasInProgress = importData.some(
        row => row.uploadStatus?.includes('InProgress') && !cancelledItems.has(row?.ilHeaderId)
      );
      // Safety-net refresh: re-fetch the authoritative list every few seconds so a finished
      // upload's status transition (and the completion popup) is picked up even if the
      // individual progress poll below is missed or errors out.
      if (hasInProgress && pollTickRef.current % 3 === 0) {
        callListAPI(currentPage, itemsPerPage, searchInput, true);
      }

      importData.forEach(row => {
        // Skip if this item was cancelled locally
        if (cancelledItems.has(row?.ilHeaderId)) {
          return;
        }

        // Only poll for progress if status is specifically 'InProgress' and not cancelled
        if (row.uploadStatus === 'InProgress' || row.uploadStatus.includes('InProgress')) {
          // Skip if this row's status includes cancelled
          if (row.uploadStatus.includes('Cancelled')) {
            return;
          }

          let callAPIPRomise = ''
          if (props?.entityName == 'ImportFarmer') {
            callAPIPRomise = ImportService.UploadProgress(row?.ilHeaderId)
          }
          if (props?.entityName == 'ImportHierarchy') {
            callAPIPRomise = ImportService.GetImportHierarchyLogProgress(row?.ilHeaderId)
          }
          if (props?.entityName == 'ImportContract') {
            callAPIPRomise = ImportService.GetImportContractLogProgress(row?.ilHeaderId)
          }
          if (props?.entityName == 'ImportWood') {
            callAPIPRomise = ImportService.GetWoodSupplierLogProgress(row?.ilHeaderId)
          }
          if (props?.entityName == 'ImportFTFAMapping') {
            callAPIPRomise = ImportService.GetFTFALogProgress(row?.ilHeaderId)
          }

          // ImportService.GetImportHierarchyLogProgress(row?.ilHeaderId)
          callAPIPRomise.then(progress => {
            if (progress !== null) {
              let p = progress?.data?.response
              if (p == 100) {
                callListAPI(currentPage, itemsPerPage, searchInput, true);
                setTimeout(() => {
                  if (setIlOriginalHEaderId != row?.ilHeaderId) {
                    callImportStatusAPI(row?.ilHeaderId)
                  }
                  setIlOriginalHEaderId = row?.ilHeaderId
                }, 10)
                return
              }

              // Stall detection: if this row's progress % hasn't moved for 20+ seconds,
              // ask the dedicated status endpoint directly instead of waiting for p === 100
              // (which never arrives if the backend fails before the per-record loop starts,
              // e.g. during setup work - progress just freezes at its last value forever).
              const now = Date.now();
              const stallInfo = progressStallRef.current[row.ilHeaderId];
              if (!stallInfo || stallInfo.value !== p) {
                progressStallRef.current[row.ilHeaderId] = { value: p, lastChangedAt: now };
              } else if (
                now - stallInfo.lastChangedAt >= 20000 &&
                !stalledStatusCheckedRef.current.has(row.ilHeaderId)
              ) {
                stalledStatusCheckedRef.current.add(row.ilHeaderId);
                callListAPI(currentPage, itemsPerPage, searchInput, true);
                callImportStatusAPI(row?.ilHeaderId);
              }

              setProgresses(prev => ({
                ...prev,
                [row.ilHeaderId]: p

              }));
            }
          }).catch(error => {
            // A failed progress poll doesn't necessarily mean the upload failed or was
            // cancelled (e.g. the task is briefly unavailable server-side). Don't mark it
            // cancelled/failed here - just skip this tick and let the periodic list refresh
            // above reconcile the real, authoritative status once it's available.
            console.log('Progress API failed for', row?.ilHeaderId, error);
          });
        }
      });
    }, 1000); // Poll every second
    // Clean up interval on component unmount or when importData changes
    return () => clearInterval(intervalId);
  }, [importData, cancelledItems]);

  function formatNumber(num) {
    return String(num).padStart(2, '0');
  }


  const setColor = (status) => {
    switch (status) {
      case 'Upload Failed':
        return '#BABBC1';
      case 'InProgress':
        return '#BABBC1';
      default:
        return 'black';
    }
  };
  const handleExportExcel = async () => {
  const sDate = dayjs(startDate).format('DD-MM-YYYY');
  const eDate = dayjs(endDate).format('DD-MM-YYYY');
  setExportLoading(true)
  try {
    // Use ImportWoodSupplier as entity name for ImportWood, otherwise use the original entity name
    const entityName = props?.entityName === 'ImportWood' ? 'ImportWoodSupplier' : props?.entityName;
    
    const res = await ImportService.FetchImportList({
      entityName: entityName,
      startDate: sDate,
      endDate: eDate,
      pageNumber: 0,
      size: 100000,
      searchquery: searchInput
    });

    const allData = res?.data?.response?.importLogHeader || [];

    if (!allData.length) {
      setMessage("No data available to export.");
      setOpenAlert(true);
      setSeverity("warning");
      return;
    }
    let excelName = ''
    if (props?.entityName == 'ImportFarmer') {
      excelName = 'Import Farmer'
    }
    if (props?.entityName == 'ImportHierarchy') {
      excelName = 'Import Hierarchy'
    }
    if (props?.entityName == 'ImportContract') {
      excelName = 'Import Contract'
    }
    if (props?.entityName == 'ImportWood') {
      excelName = 'Import Wood'
    }
    if (props?.entityName == 'ImportFTFAMapping') {
      excelName = 'Import FT to FA Mapping'
    }
    const exportFields = [
      { label: "Date", key: "importDate" },
      { label: "File Name", key: "fileName" },
      { label: "Uploaded By", key: "uploadedBy" },
      { label: "Uploaded Status", key: "uploadStatus" },
      { label: "Comments", key: "comments" },
      { label: "TimeStamp", key: "importTime" },
      { label: "Total Records", key: "totalRecordCount" },
      { label: "Success", key: "successRecordCount" },
      { label: "Failed", key: "failedRecordCount" },
    ];

 const mappedData = allData.map(item => {
      const row = {};
      exportFields.forEach(field => {
        if (field.key === "importDate" && item[field.key]) {
          // Format importDate to dd/mm/yyyy
          row[field.label] = `\t${dayjs.utc(item[field.key]).format('DD/MM/YYYY')}` 
          
        } else {
          row[field.label] = item[field.key] ?? '';
        }
      });
      
      return row;
    });
    // Create worksheet and then convert to CSV
    const worksheet = XLSX.utils.json_to_sheet(mappedData);
    const csv = XLSX.utils.sheet_to_csv(worksheet);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    saveAs(blob, `${excelName}.csv`);

  } catch (error) {
    console.error("CSV export failed:", error);
    setMessage(error?.response?.data?.message || error?.message);
    setOpenAlert(true);
    setSeverity("error");
  }finally{
    setExportLoading(false)
  }
};
  return (
    <>
      {showUpload ? (
        <div>
          <Grid container sx={{ display: "flex", justifyContent: 'space-between' }} >
            <Grid
              md={7}
              lg={7}
              sm={8}
              xs={12}
            >

              <Box sx={{ display: "flex", gap: 1, alignItems: "flex-start" }}>
                <InputLabel sx={{ width: "8rem", marginTop: "10px", alignSelf: "flex-start" }} htmlFor="my-input">
                  Comments
                </InputLabel>
                <TextField
                  disabled={read_only_user||uploadLoading}
                  onChange={(e) => setComments(e.target.value)}
                  placeholder="Type here"
                  autoFocus
                  sx={{
                    width: "100%",
                    fontStyle: "italic"
                  }}
                  multiline
                  minRows={3}
                />
              </Box>
            </Grid>
            <Grid>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  mb: 2,
                }}
              >
                <Button
                  sx={{
                    borderRadius: 100,
                    minWidth: 95,
                    minHeight: 44,
                    background: "#102A62",
                  }}
                  disabled={uploadLoading}
                  variant="contained"
                  startIcon={<KeyboardBackspaceIcon />}
                  onClick={handleBackButton}
                >
                  Back
                </Button>
              </Box>
            </Grid>
          </Grid>
          <Grid container sx={{ paddingTop: "2rem" }}>
            <Grid
              md={4}
              lg={3}
              sm={5}
              xs={12}
              sx={{ cursor: "pointer" }}
            >
              <input
                style={{ display: "none" }}
                id="contained-button-file"
                type="file"
                // multiple
                // accept=".csv"
                ref={fileInputRef}
                onChange={(e) => handleFileChange(e)}
                disabled={uploadLoading ||read_only_user}
              />
              <label htmlFor="contained-button-file">
                <Box
                  sx={{
                    backgroundColor: "#F2F6FF",
                    cursor: "pointer",
                    display: "flex",
                    padding: "20px",
                    justifyContent: "space-evenly",
                    borderRadius: "10px", // Fix here
                    height: "88px",
                    minWidth: { sm: "unset", md: "360px" },
                    alignItems: "center",
                    backgroundImage: `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='27' ry='27' stroke='rgba(126, 176, 236, 1)' stroke-width='3' stroke-dasharray='20' stroke-dashoffset='8' stroke-linecap='square'/%3e%3c/svg%3e")`, // Use backticks for template literals
                    borderRadius: "27px" // Keep in camelCase
                  }}
                >
                  <img src={uploadCloud} width="87.51px" height="" />
                  <Box
                    sx={{
                      borderRadius: 4,
                      width: 120,
                      minHeight: 50,
                      maxHeight: 54,
                       backgroundColor: read_only_user ? 'rgba(0, 0, 0, 0.12)' : (uploadLoading ? 'rgba(0, 0, 0, 0.12)' : '#EF7D00'),
                      color: "white",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      verticalAlign: "center",
                      cursor: "pointer",
                      textAlign: "center",
                      "&:hover": {
                      },
                      "&:active": {
                      },
                    }}
                  >
                    {uploadLoading && <CircularProgress sx={{ position: "absolute" }} size={15} />}
                    IMPORT
                  </Box>

                </Box>

              </label>
            </Grid>
          </Grid>
          <Box sx={{ paddingTop: "20px", gap: 2, display: "flex", flexDirection: "column" }}>
            <Box>
              Import User Guide - <a onClick={(e) => {
        if (read_only_user) {
          e.preventDefault();
          return;
        }
        handleDownloadTemplate(e, false);
      }}
       href="javascript:void(0)" style={{ color: read_only_user ? 'gray' : '#1CB9ED', textDecoration: 'underline' }}>Download</a>
            </Box>
            <Box>
              Import Template - <a  onClick={(e) => {
        if (read_only_user) {
          e.preventDefault();
          return;
        }
        handleDownloadTemplate(e, true);
      }}
      href="javascript:void(0)" style={{ color: read_only_user ? 'gray' : '#1CB9ED', textDecoration: 'underline' }}>Download</a>
            </Box>
          </Box>
         <UnsupportedModal openModal={openModal} closeOpenModal={() => clearFileInput()} />
           <TemplateDownloadModal
            open={openTemplateDownloadModal} 
            onClose={() => setOpenTemplateDownloadModal(false)}
            onConfirm={handleTemplateDownloadConfirm}
          /> 
        
        <CropYearModal
        isOpen={openCropYearModal}
        onClose={handleCloseCropYearModal}
        onConfirm={handleConfirmYear}
      />
        </div>
      ) : (
        <>
          <Box sx={{ paddingBottom: "140px" }}>
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Box sx={{
                display: "flex",
                alignItems: "center",
                fontWeight: 600,
                fontSize: "1.25rem",
                color: "rgba(115, 125, 134, 1)",
              }}>
                {props?.displayName}
              </Box>
              <Box>
                                  <Button
                    sx={{
                      borderRadius: 100,
                      minWidth: 95,
                      minHeight: 44,
                      background: "#102A62",
                      '&.Mui-disabled': {
                        backgroundColor: "#102A62", 
                        color: "#ffffff",    
                        opacity: 0.6,          
                        },
                    }}
                    variant="contained"
                    startIcon={<AddCircleIcon />}
                    onClick={() => setShowUpload(true)}
                  disabled={read_only_user}
                  >
                    Import
                  </Button>
                  {(props?.entityName !== "ImportWood" && props?.entityName !== "ImportFTFAMapping") && (
                    <Button
                                            sx={{
                                              borderRadius: "10px",
                                              minWidth: 182,
                                              minHeight: 40,
                                              background: "#0F2B63", 
                                              marginTop: "5px",
                                              marginLeft: "20px",
                                              "&:hover": {
                                                backgroundColor: "#0F2B63",
                                              },
                                              padding:'10px 14px',
                                              boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.25)", 
                                              fontFamily:"Montserrat",
                                              fontWeight:"600",
                                              fontSize:"16px",
                                    
                                            }}
                                            variant="contained"
                                            onClick={handleExportExcel}
                                            disabled={exportLoading || importData.length===0}
                                          >
                                            {exportLoading && <CircularProgress size={20} />}
                                            EXPORT TO EXCEL
                                          </Button>
                  )} 
              </Box>
            </Box>
            <Box sx={{ paddingTop: "20px", display: "flex", gap: 4, flexDirection: { xs: "column", sm: "row" } }}>
              <Box>
                <Typography sx={{ color: "rgba(115, 125, 134, 1)", padding: "10px" }}>
                  Initial Date
                </Typography>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    sx={{
                      '& .MuiInputBase-formControl': {
                        backgroundColor: "#F5F5F7 !important", fontWeight: 700,
                        border: "none !important"
                      },
                      borderRadius: "12px",
                      boxShadow: '0px 2px 6px -2px #B9B9B9',
                      "& .MuiOutlinedInput-notchedOutline": {
                        border: "none !important"  // This removes the border
                      }
                    }}
                    id="startDate"
                    name="startDate"
                    open={startDateOpen}
                    onClose={() => setStartDateOpen(false)}
                    format="DD/MM/YYYY"
                    value={startDate}
                    onChange={(newValue) => {
                      setStartDate(newValue);
                      if (endDate.isBefore(newValue)) {
                        setEndDate(newValue);
                      }
                    }}
                    minDate={minDate}
                    maxDate={endDate}
                    renderInput={(params) => <TextField variant="standard" {...params} />}
                    slotProps={{
                      field: {
                        readOnly: true,
                      },
                      textField: { variant: 'standard' },
                      textField: {
                        onClick: () => setStartDateOpen(true),
                      },
                    }}
                  />
                </LocalizationProvider>
              </Box>
              <Box>
                <Typography sx={{ color: "rgba(115, 125, 134, 1)", padding: "10px" }}>
                  End Date
                </Typography>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    sx={{
                      '& .MuiInputBase-formControl': {
                        backgroundColor: "#F5F5F7 !important", fontWeight: 700,
                        borderRadius: "12px",
                        boxShadow: '0px 2px 6px -2px #B9B9B9',
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "none !important"  // This removes the border
                        }
                      }
                    }}
                    id="endDate"
                    name="endDate"
                    open={endDateOpen}
                    onClose={() => setEndDateOpen(false)}
                    format="DD/MM/YYYY"
                    value={endDate}
                    onChange={(newValue) => {
                      setEndDate(newValue);
                      if (newValue.isBefore(startDate)) {
                        setStartDate(newValue);
                      }
                    }}
                    minDate={startDate}
                    maxDate={maxDate}
                    renderInput={(params) => <TextField  {...params} />}
                    slotProps={{
                      field: {
                        readOnly: true,
                      },
                      textField: {
                        onClick: () => setEndDateOpen(true),
                      },
                    }}
                  />
                </LocalizationProvider>
              </Box>
              <Box sx={{ minWidth: "321px", marginLeft: { sm: "auto" }, display: "flex", alignItems: "flex-end" }}>
                <TextField fullWidth className="user-search-input"
                  placeholder="Search" variant="outlined"
                  onChange={(event) => onSearch(event.target.value, itemsPerPage)}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="start">
                        {listLoading && <CircularProgress size={15} />}
                        <img src={iconSearchs} />
                      </InputAdornment>
                    ),
                    sx: {
                      borderRadius: "30px",
                      fontStyle: "italic",
                      "& .MuiOutlinedInput-notchedOutline": {
                        border: "none !important"  // This removes the border
                      }
                    }
                  }}
                />
              </Box>
            </Box>
            {importData?.length > 0 &&
              <div className="import-table-container" style={{ paddingTop: "20px" }}>
                <table className="import-table">
                  <thead>
                    <tr className="HierarchyHead">
                      <th>Date</th>
                      <th>{props?.entityName === 'ImportWood' ? 'Wood Supplier File Name' : 'File Name'}</th>
                      <th>Upload By User</th>
                      <th>Upload Status</th>
                      <th>Comments</th>
                      <th>Timestamp</th>
                      <th>Total Records</th>
                      <th>Success</th>
                      <th>Failed</th>
                      <th>View Log</th>
                    </tr>
                  </thead>
                  <tbody>
                    {importData.map((row, index) => (
                      <tr key={index} className="import-table-row">
                        <td>{convertDateString(row?.importDate)}</td>
                        <td>{row.fileName}</td>
                        <td>{row.uploadedBy
                        }</td>
                        <td style={{ color: getStatusColor(cancelledItems.has(row?.ilHeaderId) ? 'Upload Failed' : row?.uploadStatus) }}>
                          {row?.uploadStatus?.includes('InProgress') && !cancelledItems.has(row?.ilHeaderId) && !row?.uploadStatus?.includes('Cancelled') && (
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                              <LinearProgress
                                sx={{
                                  width: '100%', marginRight: 1, height: 10, minWidth: '30px',
                                  borderRadius: '10px', // Border radius
                                  '& .MuiLinearProgress-bar': {
                                    backgroundColor: '#4caf50', // Color of the filled portion (green)
                                  },
                                  '& .MuiLinearProgress-root': {
                                    backgroundColor: 'yellow !important', // Color of the unfilled portion (grey)
                                  },
                                }}
                                variant="determinate"
                                value={progresses[row.ilHeaderId] || 0}
                              />
                              <Box sx={{ boxShadow: '0px 2px 5px 2px #B9B9B9', fontSize: "8px", fontWeight: 600, textAlign: "center", borderRadius: "10px", padding: "5px", minWidth: "25px" }}>{progresses[row.ilHeaderId]}%</Box>
                              <IconButton
                                onClick={() => handleCancelClick(row?.ilHeaderId)}
                                size="small"
                              >
                                <img src={CrossRed} />
                              </IconButton>
                            </Box>
                          )}
                          {(!row?.uploadStatus?.includes('InProgress') || cancelledItems.has(row?.ilHeaderId) || row?.uploadStatus?.includes('Cancelled')) && 
                            (cancelledItems.has(row?.ilHeaderId) ? 'Upload Failed' : row.uploadStatus)
                          }
                        </td>
                        <td>{row.comments}</td>
                        <td> {row.importTime}</td>
                        <td> {formatNumber(Number(row.totalRecordCount))}</td>
                        <td style={{ color: setColor(cancelledItems.has(row?.ilHeaderId) ? 'Upload Failed' : row?.uploadStatus) }}>  {formatNumber(Number(row.successRecordCount))}</td>
                        <td style={{ color: setColor(cancelledItems.has(row?.ilHeaderId) ? 'Upload Failed' : row?.uploadStatus) }}> {formatNumber(Number(row.failedRecordCount))}</td>
                        <td>
                          {(row?.uploadStatus?.includes('InProgress') && !cancelledItems.has(row?.ilHeaderId)) || row?.totalRecordCount == 0 ?
                            <p> <img style={{ cursor: "pointer" }} src={docDisabled} /></p>
                            :
                            <p onClick={() => handleViewLog(row.ilHeaderId, {
                              fileName: row.fileName,
                              uploadedBy: row.uploadedBy,
                              uploadStatus: row.uploadStatus,
                              comments: row.comments,
                              timestamp:row.importTime,
                              totalRecords: row.totalRecordCount,
                              success: row.successRecordCount,
                              fail: row.failedRecordCount
                            })} ><img style={{ cursor: "pointer" }} src={docEnabled} /></p>
                          }
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <ImportStatusModal icon={iconName} message={ImportStatusMessage} open={openStatusModal && iconLoaded} onClose={() => {
      setOpenStatusModal(false);
      setIconLoaded(false); 
    }} />
                <ConfirmModal open={openCancelModal} onClose={() => setOpenCancelModal(false)} handleCancelConfirm={() => handleCancelConfirm()} />
              </div>
            }
            {importData?.length == 0 &&
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  flexDirection: "column",
                  alignItems: "center",
                  marginTop: "40px"
                }}
              >
                <img src={NoData} style={{ height: "100px" }} alt="No Data" />
                <p>No Data Available</p>
              </Box>}
          </Box>
          {importData?.length > 0 &&
            <div style={{ position: "absolute", width: "96%", bottom: "70px" }}>
              {importData &&
                <CustomPagination
                  itemsPerPage={itemsPerPage}
                  setItemsPerPage={(v) => setItemsPerPage(v)}
                  totalItems={totalItems}
                  paginate={paginate}
                  currentPage={currentPage}
                />
              }
            </div>
          }
        </>
      )}
    </>
  );
};

export default ImportList;
